var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.311 0.232028L0.357176 5.77766C0.245149 5.86705 0.155225 5.97794 0.0935727 6.10271C0.0319207 6.22748 0 6.36319 0 6.50052C0 6.63786 0.0319207 6.77356 0.0935727 6.89834C0.155225 7.02311 0.245149 7.13399 0.357176 7.22338L7.311 12.769C7.97475 13.2983 9 12.8595 9 12.0462V0.953302C9 0.139984 7.97475 -0.29881 7.311 0.232028Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/leftIcon.a90a6b3c91a45f436141630c698d4130.svg";
export { ForwardRef as ReactComponent };